<div class="custom-mat-form-wrapper w-full" [class.compact-field]="compact">
  <mat-form-field class="w-full" appearance="fill" [formGroup]="form" subscriptSizing="dynamic">
    <mat-date-range-input [min]="minDate" [max]="maxDate">
      <input matStartDate placeholder="Start datetime" [formControl]="form.controls.from" />
      <input matEndDate placeholder="End datetime" [formControl]="form.controls.to" />
    </mat-date-range-input>
    <button
      mat-icon-button
      matSuffix
      type="button"
      class="p-none"
      [disabled]="form.disabled"
      [matMenuTriggerFor]="menu"
      (menuClosed)="menuOpened(false)"
      (menuOpened)="menuOpened(true)"
      y42StopPropagation
    >
      <mat-icon>today</mat-icon>
    </button>
  </mat-form-field>
</div>

<mat-menu #menu y42StopPropagation class="overflow-y-auto overflow-x-hidden" yPosition="below">
  <y42-daterange-picker
    *ngIf="state.isMenuOpened"
    y42StopPropagation
    class="min-w-[250px]"
    [startDate]="form.controls.from.value"
    [endDate]="form.controls.to.value"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [timePicker]="true"
    (datesChanged)="pickerDatesChange($event)"
  ></y42-daterange-picker>
</mat-menu>
